<template>
    <div class='overview'>
        <section class="columns">
            <div class="column">
                <div class="card">
                    <header class="card-header">
                        <p class="card-header-title">
                            Alle Ansatte
                        </p>
                    </header>

                    <div class="card-content">
                        <b-table
                                :loading="loading"
                                :data="employees"
                                hoverable

                                paginated
                                pagination-simple
                                backend-pagination
                                :current-page.sync="page"
                                :total="total"
                                :per-page="limit">

                            <template slot-scope="props">
                                <b-table-column field="avatar" label="" width="10">
                                    <avatar :account="props.row" :size="32" round />
                                </b-table-column>

                                <b-table-column field="name" label="Navn" sortable>
                                    {{ props.row.name }}
                                </b-table-column>


                                <b-table-column field="created_at" label="Oprettet" sortable centered>
                                    <span class="tag is-success">
                                        {{ new Date(props.row.created_at).toLocaleDateString() }}
                                    </span>
                                </b-table-column>


                                <b-table-column field="actions" label="Handlinger" width="150">
                                    <div class="buttons">
                                        <button class="button is-small">Rediger</button>

                                        <button class="button is-small is-danger">Slet</button>
                                    </div>
                                </b-table-column>
                            </template>
                        </b-table>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style lang="scss" scoped>
    .administration {
        background: #F5F7FA;
    }
</style>

<script>
    import Avatar from '@/taskflex/users/components/Avatar';
    import EmployeeService from '@/taskflex/employees/services/EmployeeService';

    export default {
        data() {
            return {
                employees: [],
                loading: false,
                total: 0,
                page: 1,
                limit: 999,
            };
        },

        watch: {
            page() {
                this.loadEmployees();
            },
        },

        mounted() {
            this.loadEmployees();
        },

        methods: {
            loadEmployees() {
                this.loading = true;

                const options = {
                    page: this.page,
                    limit: this.limit,
                };

                EmployeeService.findAll(options, ({ data: { rows, total } }) => {
                    this.employees = rows;
                    this.total = total;

                    this.loading = false;
                });
            },
        },

        components: {
            Avatar,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/administration/pages/employees/List.vue